import { render } from "./edit.vue?vue&type=template&id=2d069cc8&ts=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__